import {
  ISearchParams,
  SortByEnum,
  SortOrderEnum,
} from '../entity-data/entity-data.data';

export const EXPENSE_FILTER_ACCEPT_VERSION = '3.1.0';
export const EXPENSE_SEARCH_ACCEPT_VERSION = '2.2.0';
export const EXPENSE_ACCEPT_VERSION = '2.1.0';
export const EXPENSE_MERCHANT_AUTOCOMPLETE_ACCEPT_VERSION = '1.0.0';

export const EXPENSE_LIST_SEARCH_PARAMS_KEY = 'expense_list_search_params';
export const ALL_YEARS = -1;

export const DEFAULT_SEARCH_PARAMS: ISearchParams = Object.freeze({
  sort_by: SortByEnum.category,
  sort_order: SortOrderEnum.asc,
  year: ALL_YEARS,
});
